<script>
import { Line } from 'vue-chartjs';
import { mapGetters } from 'vuex';

export default {
  extends: Line,
  props: {
    chartPropData: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    currentJobName: '',
    datasets: [],
    lineChartOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: true,
            },
          },
        ],
      },
      legend: {
        display: true,
      },
      responsive: true,
      maintainAspectRatio: false,
    },
    labels: [],
    matrixDataSet: [],
    currentDataSet: [],
    colorSet: {
      0: '#2897ce',
      1: '#fc833d',
      2: '#148214',
      3: '#f05a00',
      4: '#f02800',
    },
  }),
  methods: {
    initChart() {
      // Reset chart data
      this.matrixDataSet = [];
      this.currentJobName = '';
      const isString = (val) => typeof val === 'string';

      for (const [key, value] of Object.entries(this.chartPropData)) {
        this.labels = [];
        this.currentDataSet = [];

        for (const [innerKey, innerValue] of Object.entries(value)) {
          if (isString(innerValue)) {
            this.currentJobName = innerValue;
          } else {
            this.labels.push(innerValue.day);
          }

          this.currentDataSet.push(innerValue.count);
        }

        this.matrixDataSet.push(this.currentDataSet);

        this.datasets.push({
          label: this.currentJobName,
          data: this.matrixDataSet[key],
          backgroundColor: 'transparent',
          borderColor: this.colorSet[key],
          pointBackgroundColor: this.colorSet[key],
        });
      }

      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets,
        },
        this.lineChartOptions,
      );
    },
    getChartColor(colorNumber) {
      switch (colorNumber) {
        case 0:
          return '#6ebe6e';
        case 1:
          return '#913d8b';
        case 2:
          return '#fc833d';
        case 3:
          return '#2897ce';
        case 4:
          return '#465c74';
      }
    },
  },
  computed: {
    ...mapGetters(['getChartTwoData']),
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style lang="scss" scoped></style>
